import React from 'react';
import { LegendContainer, LegendText } from './Legends.styled';
import { Legends as mapLegends } from '../../../../constants/map';
import Styled, { IconWrapper } from 'components/common/Styled';
import StationIcon from 'components/common/StationIcon';
type LegendBoxProps = {
    iconSize?: string;
    display?: string;
    padding?: string;
    textPadding?: string;
    altName?: boolean;
};

export const Legends: React.FC<LegendBoxProps> = ({
    iconSize = '3.2rem',
    display = 'flex',
    padding = '2.4rem 0 0',
    textPadding = '0 4rem 0 0.8rem',
    altName = false
}) => {
    return (
        <Styled.NoBgBox style={{ display: `${display}`, padding: 0, flexWrap: 'wrap' }}>
            {mapLegends.map(legend => {
                return (
                    <LegendContainer key={legend.label} style={{ padding: `${padding}` }}>
                        <IconWrapper height={iconSize} width={iconSize}>
                            <StationIcon type={legend.type} />
                        </IconWrapper>
                        <LegendText style={{ padding: `${textPadding}` }} textVariant="body2">
                            {altName && legend.altLabel ? legend.altLabel : legend.label}
                        </LegendText>
                    </LegendContainer>
                );
            })}
        </Styled.NoBgBox>
    );
};

Legends.displayName = 'Legends';
